import { sanitizeGuid, objectDefinedNotNull } from "@pnp/common";
export function setItemMetaDataField(item, fieldName, term) {
    if (!objectDefinedNotNull(term)) {
        return Promise.resolve(null);
    }
    var postData = {};
    postData[fieldName] = {
        "Label": term.Name,
        "TermGuid": sanitizeGuid(term.Id),
        "WssId": "-1",
        "__metadata": { "type": "SP.Taxonomy.TaxonomyFieldValue" },
    };
    return item.update(postData);
}
export function setItemMetaDataMultiField(item, fieldName) {
    var terms = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        terms[_i - 2] = arguments[_i];
    }
    if (terms.length < 1) {
        return Promise.resolve(null);
    }
    return item.list.fields.getByTitle(fieldName + "_0").select("InternalName").get().then(function (i) {
        var postData = {};
        postData[i.InternalName] = terms.map(function (term) { return "-1;#" + term.Name + "|" + sanitizeGuid(term.Id) + ";#"; }).join("");
        return item.update(postData);
    });
}
//# sourceMappingURL=utilities.js.map